export default {
  title: 'Tabless',
  form: {
    tabless_id: {
      label: 'Tabless-id',
      placeholder: 'Intern ID in het Tabless-systeem',
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    error: 'Wijzigingen opslaan mislukt',
    success: 'Wijzigingen opgeslagen',
  },
  connected: {
    title: 'Tabless is verbonden',
    description: 'Deze integratie is ingesteld.',
  },
};
